import {Injectable} from '@angular/core';
import {AbstractDataServiceDtoAdapter} from 'src/app/modules/core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {PaymentRequestMovementDataService} from './paymentRequestMovementData.service';
import {PaymentRequestMovementModel} from "../../../api/entity/paymentRequestMovement.model";
import {PaymentRequestMovementConverter} from "../../../api/entity/paymentRequestMovement.converter";


@Injectable({providedIn: 'root'})
export class PaymentRequestMovementDataServiceAdapter extends
    AbstractDataServiceDtoAdapter<PaymentRequestMovementModel, PaymentRequestMovementConverter> {
    constructor(dataService: PaymentRequestMovementDataService, converter: PaymentRequestMovementConverter) {
        super(dataService, converter);
    }
    newStoredEntityInstance(): PaymentRequestMovementModel {
        return new PaymentRequestMovementModel();
    }
}
